// Shared password policy (frontend). Keep in lockstep with api/lib/passwordPolicy.js.
export const MIN_LENGTH = 12;

export function validatePassword(password: string): { valid: boolean; errors: string[] } {
  const errors: string[] = [];
  if (!password || password.length < MIN_LENGTH) {
    errors.push(`Password must be at least ${MIN_LENGTH} characters long`);
  }
  if (!/[a-z]/.test(password || '')) errors.push('Password must include a lowercase letter');
  if (!/[A-Z]/.test(password || '')) errors.push('Password must include an uppercase letter');
  if (!/[0-9]/.test(password || '')) errors.push('Password must include a number');
  return { valid: errors.length === 0, errors };
}
